import type { IOvertimeResult } from '../../../../models/overtime/OvertimeModel';
import styles from '../OvertimeManagement.module.css';

export type OvertimeStatusCellProps = {
  row: IOvertimeResult;
};

const getStatusClass = (status: string) => {
  switch (status) {
    case 'Pending':
      return styles.statusPending;
    case 'Approved':
      return styles.statusApproved;
    case 'Rejected':
      return styles.statusRejected;
    default:
      return styles.statusPending;
  }
};

const getStatusText = (status: string) => {
  switch (status) {
    case 'Pending':
      return 'Beklemede';
    case 'Approved':
      return 'Onaylandı';
    case 'Rejected':
      return 'Reddedildi';
    default:
      return 'Beklemede';
  }
};

const OvertimeStatusCell = ({ row }: OvertimeStatusCellProps) => {
  return (
    <span className={`${styles.statusBadge} ${getStatusClass(row.status)}`}>
      {getStatusText(row.status)}
    </span>
  );
};

export default OvertimeStatusCell;
